<script setup>
import PlatformBanner from './components/PlatformBanner.vue'
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <PlatformBanner />
  <Navigation />
  <router-view />
  <Footer />
</template>
